import React, { useContext } from "react";
import { FiLogOut } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { LOGIN } from "../routes";
import * as Context from "../Context/UserContext";

const Logout = ({ isMenuOpen }) => {
  const { logout } = useContext(Context.UserContext);

  const navigate = useNavigate();
  const doLogout = () => {
    logout();
    navigate(LOGIN);
  };

  return (
    <button
      onClick={doLogout}
      className={`w-full font-semibold md:border-0 rounded focus:outline-none ${
        isMenuOpen ? "text-red-500 md:hidden" : "hidden md:block"
      }`}
    >
      {isMenuOpen ? (
        <div className="flex justify-start items-center lg:items-center text-red-500 hover:bg-gray-50  dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent w-full">
          Logout
        </div>
      ) : (
        <FiLogOut className="w-8 h-8 text-red-500" />
      )}
    </button>
  );
};

export default Logout;
